import React from 'react';
import './Page.css';
import TopBar from './TopBar.js';
import PicBar from './PicBar.js';
import Footer from './Footer/Footer.js'
import Navigation from './Navigation.js';
import { useState} from 'react';
import BottomBar from './BottomBar/BottomBar';
import WelcomeWelcome from './ContentPages/WelcomeWelcome/WelcomeWelcome';
import { Route, Routes } from 'react-router-dom';
import WelcomeAbout from './ContentPages/WelcomeAbout/WelcomeAbout';
import Offering from './ContentPages/Offering/Offering.js';
import References from './ContentPages/References/References';
import Certificates from './ContentPages/Certificates/Certificates.js';
import Way from './ContentPages/Way/Way';
import MessagePage from './ContentPages/Message/MessagePage.js';
import DataPage from './BottomPages/DataPage';
import ImpPage from './BottomPages/ImpPage';
import Beratung from '../src/ContentPages/Offering/Beratung.js';
import Therapie from '../src/ContentPages/Offering/Therapie.js';
import Ablauf from '../src/ContentPages/Offering/Ablauf.js';

import Online from '../src/ContentPages/Offering/Online.js';
import Kosten from '../src/ContentPages/Offering/Kosten.js';

import Dozenten from '../src/ContentPages/Offering/Dozenten.js';
import Gesundheitsfoerderung from '../src/ContentPages/Offering/Gesundheitsfoerderung.js';








import './PageContent.css';






const Page = () => {

  console.log("page");

  const navigationItems = ['Willkommen', 'Über Mich', 'Mein Angebot', 'Referenzen', 'Bescheinigungen', 'Anfahrt'];
  const [pageposition, setPagePosition] = useState(1);



  return (
    <div className='PageWrapper'>



      <div className="BasicPage" id="page">

        <TopBar setPagePosition={setPagePosition} />
        <PicBar setPagePosition={setPagePosition} />
        <Navigation navigationItems={navigationItems} pageposition={pageposition} navnumber={1} setPagePosition={setPagePosition} />

        {(pageposition === 3) && (
          <Offering />
        )}

        <Routes>
          <Route path="/UeberMich" element={<div className='PageContent'> <WelcomeAbout /> </div>} />
          <Route path="/Ernaehrungsberatung" element={<div className='PageContent'> <Beratung /> </div>} />
          <Route path="/Ernaehrungstherapie" element={<div className='PageContent'> <Therapie /> </div>} />
          <Route path="/Online" element={<div className='PageContent'> <Online/> </div>} />
          <Route path="/Kostenuebernahme" element={<div className='PageContent'> <Kosten /> </div>} />
          <Route path="/Ablauf" element={<div className='PageContent'> <Ablauf /> </div>} />
          <Route path="/BetrieblicheGesundheitsfoerderung" element={<div className='PageContent'> <Gesundheitsfoerderung /> </div>} />
          <Route path="/Dozententaetigkeit" element={<div className='PageContent'> <Dozenten /> </div>} />
          <Route path="/Referenzen" element={<div className='PageContent'> <References /> </div>} />
          <Route path="/AerztlicheBescheinigung" element={<div className='PageContent'> <Certificates /> </div>} />
          <Route path="/Anfahrt" element={<div className='PageContent'> <Way /> </div>} />
          <Route path="/Nachricht" element={<div className='PageContent'> <MessagePage /> </div>} />
          <Route path="/Datenschutzerklaerung" element={<div className='PageContent'> <DataPage /> </div>} />
          <Route path="/Impressum" element={<div className='PageContent'> <ImpPage /> </div>} />
          <Route path="/" element={<div className='PageContent'> <WelcomeWelcome /> </div>} />
          <Route path="*" element={<div className='PageContent'> <WelcomeWelcome /> </div>} />

        </Routes>

        <Footer />
        <BottomBar setPagePosition={setPagePosition} />
      </div>
    </div>
  );
};

export default Page;